/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DailyVote
 */
export interface DailyVote {
  /**
   *
   * @type {Date}
   * @memberof DailyVote
   */
  date?: Date;
  /**
   *
   * @type {number}
   * @memberof DailyVote
   */
  numberOfVotes?: number;
  /**
   *
   * @type {number}
   * @memberof DailyVote
   */
  vimeoAlbumId?: number;
  /**
   *
   * @type {number}
   * @memberof DailyVote
   */
  charitableVimeoAlbumId?: number;
}

export function DailyVoteFromJSON(json: any): DailyVote {
  return DailyVoteFromJSONTyped(json, false);
}

export function DailyVoteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DailyVote {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    date: !exists(json, "date") ? undefined : new Date(json["date"]),
    numberOfVotes: !exists(json, "numberOfVotes")
      ? undefined
      : json["numberOfVotes"],
    vimeoAlbumId: !exists(json, "vimeoAlbumId")
      ? undefined
      : json["vimeoAlbumId"],
    charitableVimeoAlbumId: !exists(json, "charitableVimeoAlbumId")
      ? undefined
      : json["charitableVimeoAlbumId"],
  };
}

export function DailyVoteToJSON(value?: DailyVote | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    date: value.date === undefined ? undefined : value.date.toISOString(),
    numberOfVotes: value.numberOfVotes,
    vimeoAlbumId: value.vimeoAlbumId,
    charitableVimeoAlbumId: value.charitableVimeoAlbumId,
  };
}
